import type { SVGProps } from "react";

export type IconName =
  | "age"
  | "challenge"
  | "compass"
  | "copy"
  | "domain"
  | "dragon"
  | "export"
  | "faction"
  | "gem"
  | "hoard"
  | "lair"
  | "lock"
  | "menu"
  | "moon"
  | "reroll"
  | "save"
  | "share"
  | "spark"
  | "sun"
  | "threat"
  | "undo"
  | "redo";

const paths: Record<IconName, string[]> = {
  age: [
    "M12 3.5a8.5 8.5 0 1 0 8.5 8.5",
    "M12 6v6l4 2.5",
    "M4.8 4.8 7 7m10-2.2L15 7"
  ],
  challenge: [
    "M12 2.8 14.7 8l5.8.8-4.2 4 1 5.7-5.3-2.8-5.3 2.8 1-5.7-4.2-4L9.3 8Z",
    "M12 7.6v5.1"
  ],
  compass: [
    "M12 2.8a9.2 9.2 0 1 0 0 18.4 9.2 9.2 0 0 0 0-18.4Z",
    "m15.7 8.3-2.1 5.3-5.3 2.1 2.1-5.3Z"
  ],
  copy: ["M8 8h10v10H8Z", "M6 15H4V4h11v2"],
  domain: ["M4 18V8l8-4 8 4v10", "M7 18v-7l5-2.5 5 2.5v7", "M10 18v-5h4v5"],
  dragon: [
    "M19 6c-4.8-2.9-10.2-.9-11.2 3.5-.6 2.6.8 5.4 3.7 5.7 2 .2 4-1 4.5-2.8.7-2.8-2.1-4.5-4.2-3.2 1.1-3.8 6.7-3.7 8.4.2 2.2 5.3-3.3 10.8-10.5 8.1",
    "M7.5 17.2 4 20l5-1.2M18.6 6.3 21 3.8l-.8 3.6"
  ],
  export: ["M12 3v11", "m8 7 4-4 4 4", "M5 13v6h14v-6"],
  faction: [
    "M12 4.5a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4Z",
    "M5.2 19a6.8 6.8 0 0 1 13.6 0",
    "M4 8.8h3.2M16.8 8.8H20"
  ],
  gem: ["M12 3 20 8l-8 13L4 8Z", "M4 8h16", "M8 8l4 13 4-13", "m8 8 4-5 4 5"],
  hoard: [
    "M5 9.5c0-2.2 3.1-4 7-4s7 1.8 7 4-3.1 4-7 4-7-1.8-7-4Z",
    "M5 9.5v5c0 2.2 3.1 4 7 4s7-1.8 7-4v-5",
    "M7 13.5c1.3 1.1 3.1 1.7 5 1.7s3.7-.6 5-1.7"
  ],
  lair: [
    "M4.2 18.5c.7-6 4.3-11.2 7.8-13 3.5 1.8 7.1 7 7.8 13",
    "M7.3 18.5c.4-3.4 2.2-6.2 4.7-7.3 2.5 1.1 4.3 3.9 4.7 7.3",
    "M3 18.5h18"
  ],
  lock: ["M7 10V7.8a5 5 0 0 1 10 0V10", "M6 10h12v10H6Z", "M12 14v2.5"],
  menu: ["M4 7h16", "M4 12h16", "M4 17h16"],
  moon: ["M19 15.4A7.2 7.2 0 0 1 8.6 5a8.3 8.3 0 1 0 10.4 10.4Z"],
  reroll: ["M18.5 7.5A7.5 7.5 0 0 0 5.4 8", "M18.5 4v3.5H15", "M5.5 16.5A7.5 7.5 0 0 0 18.6 16", "M5.5 20v-3.5H9"],
  save: ["M5 4h12l2 2v14H5Z", "M8 4v6h8V4", "M8 20v-6h8v6"],
  share: ["M8.2 13.4 15.8 17.6", "M15.8 6.4 8.2 10.6", "M6 14.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z", "M18 7.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z", "M18 21.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z"],
  spark: ["M12 3v5", "M12 16v5", "M3 12h5", "M16 12h5", "m6 6 2.8 2.8", "m15.2 15.2 2.8 2.8", "m18 6-2.8 2.8", "m8.8 15.2-2.8 2.8"],
  sun: ["M12 6.2a5.8 5.8 0 1 0 0 11.6 5.8 5.8 0 0 0 0-11.6Z", "M12 2v2.2M12 19.8V22M2 12h2.2M19.8 12H22M4.9 4.9l1.6 1.6M17.5 17.5l1.6 1.6M19.1 4.9l-1.6 1.6M6.5 17.5l-1.6 1.6"],
  threat: ["M12 3 21 20H3Z", "M12 8v5", "M12 17h.01"],
  undo: ["M9 7H4v5", "M5 12a7 7 0 1 0 2.1-5"],
  redo: ["M15 7h5v5", "M19 12a7 7 0 1 1-2.1-5"]
};

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

export function Icon({ name, className, ...props }: IconProps) {
  return (
    <svg className={`ui-icon ${className ?? ""}`} viewBox="0 0 24 24" aria-hidden="true" {...props}>
      {paths[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
